import config from "@/config";
import fetchWrapper from "@/services/fetchWrapper.service";

const API_BASE = config.apis.api.url;
const PROFILE_ENDPOINT = `${API_BASE}/user/payment-profile/`;
const PAYMENT_METHODS_BASE = `${API_BASE}/user/payment-methods`;

function buildPaymentMethodsUrl(path = "") {
  const normalized = path ? `/${path.replace(/^[/]+/, "")}` : "/";
  return `${PAYMENT_METHODS_BASE}${normalized}`;
}

async function getProfile() {
  return fetchWrapper.get(PROFILE_ENDPOINT, {
    injectToken: true,
  });
}

async function updateProfile({
  billingAddress,
  billingInfo,
  country,
} = {}) {
  const body = {};

  if (billingAddress) {
    body.billing_address = billingAddress;
  }

  if (billingInfo) {
    body.billing_info = billingInfo;
  }

  if (country) {
    body.country = country;
  }

  return fetchWrapper.put(PROFILE_ENDPOINT, {
    injectToken: true,
    body,
  });
}

async function verifyVatId({
  vatId,
  billingAddress,
  billingInfo,
} = {}) {
  return fetchWrapper.post(`${PROFILE_ENDPOINT}vat/verify/`, {
    injectToken: true,
    body: {
      vat_id: vatId,
      billing_address: billingAddress,
      billing_info: billingInfo,
    },
  });
}

async function createSetupIntent({ country }) {
  return fetchWrapper.post(buildPaymentMethodsUrl("setup-intent/"), {
    injectToken: true,
    body: { country },
  });
}

async function confirmProfile({
  paymentMethodId,
  intentId,
  country,
  mode,
  pendingBid,
  cardholderName,
}) {
  const body = {
    payment_method_id: paymentMethodId,
    intent_id: intentId,
    country,
    mode,
  };

  if (typeof cardholderName === "string" && cardholderName.trim()) {
    body.cardholder_name = cardholderName.trim();
  }

  if (pendingBid && typeof pendingBid === "object") {
    body.pending_bid = pendingBid;
  }

  return fetchWrapper.post(buildPaymentMethodsUrl("confirm/"), {
    injectToken: true,
    body,
  });
}

async function acknowledgeAuthorization({ intentId, paymentMethodId, country }) {
  return fetchWrapper.post(buildPaymentMethodsUrl("authorization/ack/"), {
    injectToken: true,
    body: {
      intent_id: intentId,
      payment_method_id: paymentMethodId,
      country,
    },
  });
}

async function listPaymentMethods() {
  return fetchWrapper.get(buildPaymentMethodsUrl(), {
    injectToken: true,
  });
}

async function setDefaultPaymentMethod(paymentMethodId) {
  return fetchWrapper.post(buildPaymentMethodsUrl("default/"), {
    injectToken: true,
    body: {
      payment_method_id: paymentMethodId,
    },
  });
}

async function deletePaymentMethod(paymentMethodId) {
  return fetchWrapper.delete(buildPaymentMethodsUrl(`${paymentMethodId}/`), {
    injectToken: true,
  });
}

const paymentProfileService = {
  getProfile,
  updateProfile,
  verifyVatId,
  createSetupIntent,
  confirmProfile,
  acknowledgeAuthorization,
  listPaymentMethods,
  setDefaultPaymentMethod,
  deletePaymentMethod,
};

export default paymentProfileService;
